<template>
  <div class="register-form">

        <el-form :model="regCreds" :rules="validators" ref="regCreds">
          <el-form-item  prop="username">
            <el-input type="text" v-model="regCreds.username" class="login-input" placeholder="Email"></el-input>
          </el-form-item>

          <el-form-item  prop="password">
            <el-input type="password" v-model="regCreds.password" auto-complete="off" class="login-input" placeholder="Password"></el-input>
          </el-form-item>

          <el-form-item  prop="checkPass">
            <el-input type="password" v-model="regCreds.checkPass" auto-complete="off" class="login-input" @keyup.enter.native="submit('regCreds')" placeholder="Confirm Password"></el-input>
          </el-form-item>
        
          <div @click="changeToLogin" class="fpLink">Already have an account? Click here to sign in.</div>

          <div class="login-btns">
            <el-button type="add" @click="submit('regCreds')">Register</el-button>
            <!-- <el-button type="cancel" @click="reset('credentials')">Reset</el-button> -->
          </div>
          
        </el-form>


      </div>

</template>

<script>
import requests from '../requests'
import auth from '../auth'

export default {
  name: 'registerform',
  props: ['redirect'],
  data(){
    
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password'));
      } else if (!value.match(/[a-z]+/) || !value.match(/[A-Z]+/) || !value.match(/[0-9]+/) ) {
        callback(new Error('Passwords must contain at least one upper case, one lower case letter, and one number.'))
      } else if (value.length < 6) {
        callback(new Error('Password must be more than 6 characters'));
      } else {
        if (this.checkPass !== '') {
          this.$refs['regCreds'].validateField('checkPass');
        }
      }
      callback();
    };

    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password again'));
      } else if (value !== this.regCreds.password) {
        callback(new Error('Two inputs don\'t match!'));
      }

      callback();
    };

    var validateEmail = (rule, value, callback) => {
      var emailRegex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      if(!value.trim().match(emailRegex)) {
        callback(new Error("Not a valid email address."));
      }
      callback();
    };

    return {
      regCreds: {
        username: '',
        password: '',
        checkPass: '',
      },

      validators: {
        username: [
          { required: true, message: "Please input an email.", trigger: 'blur'},    
          { min:2, max: 99, message: "Must be between 2-99 characters.", trigger: 'blur' },
          { validator: validateEmail }            
        ],
        password: [
          { validator: validatePass }
        ],
        checkPass: [
          { validator: validatePass2 }
        ],
      },
    }
  },
  methods: {
    changeToLogin() {
      this.$emit('login');
    },
    newUser(){
      var userData = this.regCreds;
      userData.name = null;
      userData.email = userData.username;
      userData.client_id = 2;
      userData.role = 0;
      userData.generated_pass = 0;

      //Clone userdata for email, otherwise gets cleared
      var udcopy = Object.assign({}, userData);

      var context = this;
      requests.registerUser(this, userData, function(result){
        if(result.action === 'success'){

          context.$message({
            showClose: true,
            type: 'success',
            message: 'Successfully created user ' + userData.username
          });

          auth.login(context, context.regCreds, context.redirect || context.$route.path);


        } else {
          console.log(userData);
          console.log(result);
          if(result.message === "Duplicate entry found") { 
            context.$message({
              showClose: true,
              type: 'error',
              message: 'Someone with that email already exists.'
            });
          } else {
            context.$message({
              showClose: true,
              type: 'error',
              message: 'Failed to create new user'
            });
          }
        }
      });
    },
    submit(formName) {
      // console.log(this.userData);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log('Valid');
          this.newUser();
          // this.reset(formName);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
}
</script>

<style>
  .register-form  {
    background-color: white;
    display: inline-block;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// RegisterForm.vue?d40d20a2